import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from "strongly-typed-events";
import { ControladorBase } from '@/components/a-interfaz/a-controlador';
import { isNumber, isString } from 'util';
import { Utiles } from '@/__env/pluggins/event-bus';
import router from '@/__env/router.index';
import { Articulo } from '@/__env/lib/Articulos';
import { MensajeAutomatico } from '@/__env/lib/Chats/MensajeAutomatico/MensajeAutomatico.nav';

export class ControladorInterfaz extends ControladorBase
{
    constructor()
    {
        super();
        this.Vista.Titulo = 'Padrones IIBB';
    }

    public Mensajes: MensajeAutomatico[] = [];
    async Iniciar( )
    {
        let e = await MensajeAutomatico.find( {} );
        if ( e.Items )
        {
            this.Mensajes = e.Items;
        }
        this.Vista.Modo = 'resumen';
        this.Vista.Estado = 'iniciado';

    }


    async Recargar()
    {
        await this.Iniciar();
    }

}

export const Controlador = new ControladorInterfaz();


